module.exports = {"130727100":"西城镇","130727101":"东城镇","130727102":"化稍营镇","130727103":"揣骨疃镇","130727104":"东井集镇","130727200":"要家庄乡","130727201":"东坊城堡乡","130727202":"井儿沟乡","130727203":"三马坊乡","130727204":"高墙乡","130727205":"大田洼乡","130727206":"辛堡乡","130727207":"马圈堡乡","130727208":"浮图讲乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130727.json
// module id = 277
// module chunks = 0